import { initContract } from '@ts-rest/core';
import { adminLeaderboardContract } from './leaderboard.admin.contract';
import { authLeaderboardContract } from './leaderboard.auth.contract';
import { publicLeaderboardContract } from './leaderboard.public.contract';

const c = initContract();

export const leaderboardContract = c.router(
  {
    admin: adminLeaderboardContract,
    auth: authLeaderboardContract,
    public: publicLeaderboardContract,
  },
  {
    pathPrefix: '/draw/leaderboard',
    strictStatusCodes: true,
  }
);

export * from './leaderboard.admin.contract';
export * from './leaderboard.auth.contract';
export * from './leaderboard.public.contract';
export * from './models';

